module.exports = __webpack_public_path__ + "static/JLP-2ef4166b55043b470c951d592900f894.jpeg";